import styled from 'styled-components';

export const Container = styled.div`
  padding-top: ${(props) => (props.noPadding || props.noPaddingTop ? '0px' : '25px')};
  padding-bottom: ${(props) => (props.noPadding || props.noPaddingBottom ? '0px' : '25px')};
  padding-left: ${(props) => (props.noPadding || props.noPaddingLeft ? '0px' : '25px')};
  padding-right: ${(props) => (props.noPadding || props.noPaddingRight ? '0px' : '25px')};
`;
